import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.theme ? _c('ThemeProvider', {
    staticClass: "v-preview",
    attrs: {
      "theme": _vm.theme,
      "inject-locally": ""
    }
  }, [_c('ScaledDevice', {
    attrs: {
      "width": 428,
      "height": 868
    }
  }, [_c('DeviceIphone', [_vm.loading ? _c('Skeleton', {
    attrs: {
      "width": "100%",
      "height": "100%"
    }
  }) : [_c('PreviewProfile', _vm._b({
    ref: "preview"
  }, 'PreviewProfile', _vm.$props, false), [_c('template', {
    slot: "beforeLinks"
  }, [_vm._t("beforeLinks")], 2), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _vm._t("afterProfile")]], 2)], 1)], 1) : _c('ScaledDevice', {
    staticClass: "v-preview",
    attrs: {
      "width": 428,
      "height": 868
    }
  }, [_c('DeviceIphone', [_vm.loading ? _c('Skeleton', {
    attrs: {
      "width": "100%",
      "height": "100%"
    }
  }) : [_c('PreviewProfile', _vm._b({
    ref: "preview"
  }, 'PreviewProfile', _vm.$props, false), [_c('template', {
    slot: "beforeLinks"
  }, [_vm._t("beforeLinks")], 2), _vm._v(" "), _vm.$slots.default ? [_vm._t("default")] : _vm._e(), _vm._v(" "), _c('template', {
    slot: "afterLinks"
  }, [_vm._t("afterLinks")], 2)], 2), _vm._v(" "), _vm._t("afterProfile")]], 2)], 1);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = "data-v-030585a3";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };